<div ngbDropdown>
    <button class="action-icon lg" ngbDropdownToggle>
        <far i="ellipsis-v"></far>
    </button>
    <div ngbDropdownMenu #dropdownMenu class="dd-menu"></div>
</div>
